/**
 * Currencies stored in their own unit on this Stripe account (no minor-unit
 * subdivision). Add to this set if Stripe ever charges another zero-decimal
 * currency (JPY, KRW, etc.) without paise/cents subdivision.
 */
const ZERO_DECIMAL_CURRENCIES = new Set(['INR']);

const formatCurrency = (value: number, locale: string, currency: string) => {
  // Most currencies are stored in minor units (pence/cents) and need a
  // /100 conversion for display. INR on this account is stored in whole
  // rupees (matches Stripe's INR plan units), so no division.
  const convertedValue = ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase())
    ? value
    : value / 100;

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });

  return formatter.format(convertedValue);
};

export default formatCurrency;
